export default __webpack_public_path__ + "static/media/mongo.f833ecf6.jpg";